import { Log } from "~/extensions/utils";
import { defineComponent, ref } from "vue";
import dayjs from "dayjs";
import { myPageStore } from "~/store/MyPageStore";
import { FileCode, KeyReturnAdrKb, KeyReturnNameKb, TaikyoRiyuKb } from "~/extensions/utils/DefineTypes";
import FilePreview from "~/components/FilePreview.vue";
import { useTaikyoFilePreview } from "~/pages/taikyo/notification/Models/useTaikyoFilePreview";
const log = Log.create("TaikyoNotificationCheckList");
export default defineComponent({
    name: "taikyoNotificationCheckList",
    components: {
        FilePreview
    },
    props: {
        row: {
            type: Object,
            required: true
        },
        columns: {
            type: Array,
            required: true
        },
        taikyoForInput: {
            type: Object,
            required: true
        },
        result: {
            type: Object,
            required: false
        },
        fileInfo: {
            type: Object,
            required: false
        }
    },
    setup(props) {
        const isMMA = myPageStore.personal.isMma;
        const filePreview = useTaikyoFilePreview();
        let date = ref("");
        let time = ref("");
        function applyDateTime(row) {
            if (date.value && time.value) {
                row.keyReturnStrYmd = `${date.value} ${time.value}`;
            }
            date.value = "";
            time.value = "";
        }
        return {
            props,
            isMMA,
            date,
            time,
            applyDateTime,
            dayjs,
            myPageStore,
            TaikyoRiyuKb,
            KeyReturnNameKb,
            KeyReturnAdrKb,
            FileCode,
            ...filePreview
        };
    }
});
